import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import styled from "styled-components";
import Config from "./Config/Config";
import { NavLink } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import { LoginPopupContext } from "./Context/ShowLoginPopup";
import AlertPopupMessage from "./ErrorPopus/AlertPopus";
import { useLocation } from "react-router-dom";
import { useConfig } from "./Context/ConfigContext";
import toast from "react-hot-toast";

const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  margin: 0;
  align-items: center;

  li {
    padding: 18px 10px;
  }

  @media (max-width: 768px) {
    flex-flow: column nowrap;
    background-color: #fff;
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(1000%)")};
    top: 0;
    left: 0;
    z-index: 99999 !important;
    height: calc(100% - 60px);
    width: 100%;
    padding: 2.5rem 1.5rem;
    transition: transform 0.3s ease-in-out;
    display: flex;
    align-items: flex-start;
    padding-left: 10px !important;
  }
`;

const RightNav = ({ open }) => {
  // check users is Login so Please to print the users name on the
  const CurrentLocation = useLocation();
  const { config } = useConfig();

  const formRef = useRef(null);
  const LoginStatus = JSON.parse(localStorage.getItem("AccessLogin")) ?? {};
  const { OpenLoginPops, setOpen } = useContext(LoginPopupContext);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setOpen(false);
  };
  const handleShow = () => setShow(true);
  const [number, setNumber] = useState();
  const [GetOtp, setOtp] = useState("");
  let [reSendOtpCounter, setResendOtpCounter] = useState(0);
  const [resendStatus, setResendStatus] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  const [makeItTrue, setMakeItTrue] = useState(true);
  const Navigations = useNavigate();

  // Generate otp for mobile numbers
  const GeneratesOtp = (e) => {
    e.preventDefault();
    if (!number || String(number).length - 1 > 10) {
      toast.error("mobile number must be 10 digits")
      return;
    }
    // called the Apis that we can get otp
    let Payloads = {
      mobile_no: number,
    };
    axios
      .post(
        `${Config.API_URL}/api/customer/login`,
        JSON.parse(JSON.stringify(Payloads)),
        {
          headers: {
            Authorization: `${Config.API_ACCESS_TOKEN}`,
          },
        }
      )
      .then((responses) => {
        // set the TimeOut counter
        if (responses.data.status) {
          setResendOtpCounter(60);
          setResendStatus(true);
          setMakeItTrue(false)
          toast.success( `${responses.data.message}`)
          return;
        } else {
          toast.error( `${responses.data.message}`)
          return;
        }
      })
      // handle errors Response
      .catch((err) => {
        toast.error(`${err.response.data.message}` || err?.message || "Internal server Error")
        return;
      });
  };
  // Re-send otp of otp and send User details
  const Re_Send_OTP = (e) => {
    e.preventDefault();
    if (number.length !== 10) {
      toast.error( `mobile number must be 10 digits`)
      return;
    }
    let Payloads = {
      mobile_no: parseInt(number),
    };
    axios
      .post(
        `${Config.API_URL}/api/customer/resendotp`,
        JSON.parse(JSON.stringify(Payloads)),
        {
          headers: {
            Authorization: `${Config.API_ACCESS_TOKEN}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setResendOtpCounter(60);
          setResendStatus(true);
          toast.success( `${response.data.message}`)
          return;
        } else {
          toast.success( `${response.data.message}`)
          return;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // clear the setTime interval to manage the Data
  useEffect(() => {
    let intervalId = setInterval(() => {
      setResendOtpCounter((prevCounter) => {
        if (prevCounter > 0) {
          return prevCounter - 1;
        } else {
          clearInterval(intervalId);
          return prevCounter;
        }
      });
    }, 1000);
    // Clean up the interval
    return () => clearInterval(intervalId);
  }, [reSendOtpCounter]);

  // send the resend status is false
  useEffect(() => {
    if (reSendOtpCounter === 0) {
      setResendStatus(false);
      setResendButton(true);
    }
  }, [reSendOtpCounter]);

  // Match otp for the User
  const MatchOtp = (e) => {
    e.preventDefault();
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    // here is random string to
    const randomString =
      Math.random().toString(20).substring(2, 14) +
      Math.random().toString(20).substring(2, 14);

    const deviceID = `${userAgent}-${platform}-${randomString}`;
    // validating the input
    if (number?.length !== 10) {
      toast.error( `mobile number must be 10 digits`)
      return;
    }

    if (GetOtp?.length !== 4) {
      toast.error( `OTP must be 4 digits`)
      return;
    }

    let Payloads = {
      mobile_no: number,
      otp: GetOtp,
      device_id: deviceID,
      fcm_id: randomString,
    };
    // called the API and send back to the Users Profiles channels
    axios
      .post(
        `${Config.API_URL}/api/customer/matchotp`,
        JSON.parse(JSON.stringify(Payloads)),
        {
          headers: {
            Authorization: `${Config.API_ACCESS_TOKEN}`,
          },
        }
      )
      .then((response) => {
        if (!response.data.status) {
          toast.error( `${response.data.message}`)
          return;
        }
        localStorage.setItem("AccessLogin", JSON.stringify(response.data.data));

        // check if current location path name is root path something like that
        if (CurrentLocation.pathname === '/cab-listing') {
          setShow(false)
          // here reset the form using resets
          if (formRef.current) {
            formRef.current.reset();
          }
          toast.success( `Login success !`)
          return;
        } else {
          Navigations("/dashboard/my-profile");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    setShow(OpenLoginPops);
  }, [OpenLoginPops]);

  const LogoutUsers = useCallback((e) => {
    // clearing session storages
    e.preventDefault();
    let Payloads = {
      _id: LoginStatus._id,
    };
    // called the backend API to Logout
    axios
      .post(
        `${Config.API_URL}/api/customer/logout`,
        JSON.parse(JSON.stringify(Payloads)),
        {
          headers: {
            Authorization: `${Config.API_ACCESS_TOKEN}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          localStorage.removeItem("AccessLogin");
          Navigations("/");
          return;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  });

  return (
    <>
      <AlertPopupMessage />
      <Modal
        className="loginpop"
        show={show ?? OpenLoginPops}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={MatchOtp} ref={formRef}>
            <Form.Group className="mb-3 position-relative" controlId="">
              <Form.Label>Mobile Number</Form.Label>
              <img src={'/images/mob.svg'} alt="mobile number" title="mobile number" />
              <Form.Control
                type="number"
                placeholder="Enter your mobile number"
                value={number}
                maxLength={10}
                onChange={(e) => {
                  if (/^\d{0,10}$/.test(e.target.value)) {
                    setNumber(e.target.value);
                  }
                }}
              />
              {
                makeItTrue && <button onClick={GeneratesOtp} className="smltrns_btn">
                  Send OTP
                </button>
              }
            </Form.Group>
            <Form.Group className="mb-3" controlId="">
              <Form.Label>Enter OTP received</Form.Label>
              {/* manage the OTP Errors */}
              <Form.Control
                type="number"
                placeholder="Enter 4 digit OTP"
                value={GetOtp}
                maxLength={4}
                onChange={(e) => {
                  if (/^\d{0,4}$/.test(e.target.value)) {
                    setOtp(e.target.value);
                  }
                }}
              />
              {resendStatus ? (
                <>
                  <p>Resend OTP in {reSendOtpCounter} Second</p>
                </>
              ) : (
                <>
                  {
                    !makeItTrue && <button onClick={Re_Send_OTP} className="smltrns_btn resndbtn">
                      Resend
                    </button>
                  }
                </>
              )}
            </Form.Group>
            <Button variant="primary" type="submit" disabled={GetOtp?.length !== 4}>
              Submit <ArrowForwardIcon />
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Ul open={open}>
        <div className="mobprofl_menu">
          <img src={'/images/user.png'} alt="user_logo" title="user logo" />
          <h6>Guest User</h6>
          <p>
            Sign up and get job or internship assurance benefits right from
            start
          </p>
        </div>
        <li className="nav-item">
          <NavLink className="nav-link" aria-current="page" to="/">
            {" "}
            Home{" "}
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="/drive-with-us">
            {" "}
            Register your taxi{" "}
          </NavLink>
        </li>
        <li className="nav-item mobshow">
          <NavLink className="nav-link" to="/about-us">
            About Us
          </NavLink>
        </li>
        <li className="nav-item mobshow">
          <NavLink className="nav-link" to="/contact-us">
            Contact Us
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to={config?.app_link}>
            <img src={'/images/download.png'} alt='downloads apps' title="download app"
              width={52}
              height={52}
              style={{ width: "auto", height: "auto" }}
            /> Download Our App
          </NavLink>
        </li>
        <li className="nav-item mobhide">
          <div class="hdrbtn">
            <a href="tel:+91-9054865866" className="sitehdrbtn">
              Call +91-9054865866
            </a>
          </div>
        </li>
        {Object.entries(LoginStatus).length === 0 ? (
          <li className="nav-item">
            <NavLink className="nav-link" onClick={handleShow}>
              <img src={'/images/user.png'} alt="user login" title="user login"
                width={52}
                height={52}
                style={{ width: "auto", height: "auto" }}
              /> Login
            </NavLink>
          </li>
        ) : (
          <li className="d-flex">
            <PersonIcon className="colorChange" />
            <NavDropdown title={LoginStatus.full_name} id="basic-nav-dropdown" >
              <NavDropdown.Item href="/dashboard/my-profile" className="userdropdown">
                Profile
              </NavDropdown.Item>

              <NavDropdown.Item href="/dashboard/my-bookings" className="userdropdown">
                My Bookings
              </NavDropdown.Item>

              <NavDropdown.Item onClick={(e) => LogoutUsers(e)} className="userdropdown">
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </li>
        )}

        <div className="moblmenu_btn">
          <a href="#" className="navbtn" >
            Login
          </a>
        </div>
        <div className="mobshow sidesocial social topMargin11x">
          <h5>Our Social Presence</h5>
          <ul>
            <li> <a
              href="https://www.facebook.com/buzzway01/"
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Follow Buzzway on Facebook"
              title="Follow Buzzway on Facebook"

            >
              <img
                src={'images/facebook.svg'}
                alt="Follow Buzzway on Facebook"
                title="Follow Buzzway on Facebook"
              />
            </a> </li>
            <li> <a
              href="https://www.instagram.com/buzzwaytaxiservice/"
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Follow Buzzway on Instagram"
              title="Follow Buzzway on Instagram"
            ><img
                src={'/images/insta.svg'}
                alt="Follow Buzzway on Instagram"
                title="Follow Buzzway on Instagram"
              /> </a> </li>
            <li> <a
              href="https://twitter.com/buzzway01/"
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Follow Buzzway on Twitter"
              title="Follow Buzzway on Twitter"


            ><img
                src={'/images/twitter.svg'}
                alt="Follow Buzzway on Twitter"
                title="Follow Buzzway on Twitter"
              /> </a> </li>
            <li> <a
              href="https://www.youtube.com/channel/UCmk1a_siIybosrgdJrHCcww"
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Follow Buzzway on YouTube"
              title="Follow Buzzway on YouTube"
            ><img
                src={"/images/yt.svg"}
                alt="Follow Buzzway on YouTube"
                title="Follow Buzzway on YouTube"

              /> </a> </li>
          </ul>
        </div>
      </Ul>
    </>
  );
};

export default RightNav;
